export default __webpack_public_path__ + "static/media/arrow.a0254ce7.svg";